import { useCallback, useEffect } from "react";
export function useClickAway(element, listener) {
    const handleWindowClick = useCallback((e) => {
        if (element && e.target instanceof Node && !element.contains(e.target)) {
            listener();
        }
    }, [element, listener]);
    useEffect(() => {
        window.addEventListener("click", handleWindowClick, true);
        return () => window.removeEventListener("click", handleWindowClick, true);
    }, [handleWindowClick]);
}
//# sourceMappingURL=useClickAway.js.map